const MICROSERVICES = {
  PROGRAMMANAGER: 'programs-mgr',
  SITEMANAGER: 'site-mgr',
  DISPATCHMANAGER: 'dispatch-mgr',
  ENROLLMENTMANAGER: 'enrollment-mgr',
  SESSIONMANAGER: 'session-mgr',
  VPPMANAGER: 'vpp-mgr',
  REPORTMANAGER: 'reports-mgr',
  TELEMETRYMANAGER: 'telemetry-mgr'
}

const SORTORDER = {
  ASC: 'ascending',
  DESC: 'descending'
}

export {
  MICROSERVICES,
  SORTORDER
}